import React, { useEffect, useState } from "react";
import ClientLayout from "../../../components/client/ClientLayout";
import RequireClientAdmin from "../../../components/client/RequireClientAdmin";
import EmailsTab from "../../../components/EmailsTab";
import EmailProviderPanel from "../../../components/EmailProviderPanel";
import { clientApi, clientApiAsAdmin } from "../../../api";

export default function SettingsEmails() {
  const [venue, setVenue] = useState(null);
  const [flash, setFlash] = useState(null);

  useEffect(() => {
    clientApi.getMe().then((m) => setVenue(m.venue)).catch(() => {});
  }, []);

  return (
    <ClientLayout>
      <RequireClientAdmin>
        <div className="venues-page-header">
          <div>
            <h1>Emails</h1>
            <p className="page-subtitle">Templates and delivery provider</p>
          </div>
        </div>

        {flash && (
          <div className={`toast toast-${flash.type === "success" ? "success" : "error"}`} style={{ marginBottom: "1rem" }}>
            {flash.msg}
          </div>
        )}

        {venue && (
          <>
            <EmailProviderPanel
              venueId={venue.id}
              api={clientApiAsAdmin}
              onFlash={(type, msg) => {
                setFlash({ type, msg });
                setTimeout(() => setFlash(null), 3500);
              }}
            />
            <div style={{ marginTop: "2rem" }}>
              <EmailsTab venueId={venue.id} venue={venue} api={clientApiAsAdmin} />
            </div>
          </>
        )}
      </RequireClientAdmin>
    </ClientLayout>
  );
}
